import { render } from "./GradientLayout.vue?vue&type=template&id=501d46da&scoped=true"
import script from "./GradientLayout.vue?vue&type=script&lang=js"
export * from "./GradientLayout.vue?vue&type=script&lang=js"

import "./GradientLayout.vue?vue&type=style&index=0&id=501d46da&lang=less&scoped=true"

import exportComponent from "/builds/sqMDsSTzB/0/dsp/plazkart-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-501d46da"]])

export default __exports__